import {Dispatch} from "react";
import {IActionType, IGetCityParams, IIdValuePairResponse} from "../../interfaces/Index";
import * as actionTypes from "../actionTypes/Index";
import {fetchCitiesApiCall} from "../sources/GlobalProductSource";

export const getCitiesInit = () => ({
  type: actionTypes.GET_CITIES_INIT,
});

export const getCitiesSuccess = (payload: IIdValuePairResponse[]) => ({
  type: actionTypes.GET_CITIES_SUCCESS,
  payload,
});

export const getCitiesFail = (error: string | object | null) => ({
  type: actionTypes.GET_CITIES_FAIL,
  error,
});

// async actions
export const fetchCities = () => (dispatch: Dispatch<IActionType>) => {
    const queryParams: IGetCityParams = {zoneType : "CITY"};
    dispatch(getCitiesInit());
    return fetchCitiesApiCall(queryParams)
        .then((cities: IIdValuePairResponse[]) => dispatch(getCitiesSuccess(cities)))
        .catch((e: object | null | string) => dispatch(getCitiesFail(e)));
};
